import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { debounceTime } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/auth.service";
import * as i2 from "@angular/router";
import * as i3 from "../services/config.service";
export class AuthReverseGuard {
    constructor(authService, router, configService) {
        this.authService = authService;
        this.router = router;
        this.configService = configService;
        this.loader$ = new Subject();
        this.loader = false;
        this.loader$.pipe(debounceTime(300)).subscribe(loader => { this.loader = loader; });
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug("AuthReverseGuard");
            this.setShowLoader(true);
            try {
                yield this.configService.getInitialInfo();
                var isLogged = yield this.authService.checkAutentication();
            }
            catch (error) {
                this.setShowLoader(false);
                this.router.navigateByUrl('/inicio');
                this.configService.getInitialInfo(true);
                return true;
            }
            if (!isLogged) {
                this.setShowLoader(false);
                return true;
            }
            this.setShowLoader(false);
            this.router.navigateByUrl('/inicio');
            this.configService.getInitialInfo(true);
            return false;
        });
    }
    setShowLoader(show) {
        this.loader$.next(show);
    }
}
AuthReverseGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthReverseGuard_Factory() { return new AuthReverseGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.ConfigService)); }, token: AuthReverseGuard, providedIn: "root" });
